<template>
  <v-card>
    <v-card-title> 单位选择 </v-card-title>

    <v-list flat>
      <v-list-item-group color="primary">
        <v-list-item v-for="item in organizations" :key="item.id">
          <v-list-item-content @click="onSelect(item)">
            <v-list-item-title v-text="item.name"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-card>
</template>

<script>
import { refreshToken, saveTokenCache } from "@/utils/token";
export default {
  data() {
    return {
      selectedItem: 1,
    };
  },
  computed: {
    organizations() {
      return this.$store.getters.organizationList;
    },
  },
  methods: {
    async onSelect(item) {
      const loading = this.$loading();
      localStorage.setItem("organizationId", item.id);
      const data = await refreshToken();
      saveTokenCache(data);
      loading.close();
      window.location.reload();
    },
  },
};
</script>

<style></style>
